import {parameterValue} from "#graph/nodes/graph/helpers"
import {z} from "zod/v4-mini"
import {GraphNode} from "#graph/nodes/graph/graph-node"
import {registerGraphNode} from "#graph/decorators/register-node"
import type {Evaluator} from "#graph/evaluators/types"
import type {StructParameters} from "#graph/nodes/struct/definition"
import {structDefinition} from "#graph/nodes/struct/definition"
import {lazyDefinition} from "#graph/helpers/lazy-definition"

export abstract class Struct<StructType extends {[key in Key]: unknown}, Key extends string = string, Context = unknown> extends GraphNode<
    StructType,
    Context,
    StructParameters<StructType, Key>
> {
    override run = async (evaluator: Evaluator<Context>) => {
        return evaluator.getAll(this.parameters.struct) as Promise<StructType>
    }

    override runSync = (evaluator: Evaluator<Context>) => {
        return evaluator.getAllSync(this.parameters.struct) as StructType
    }
}

const numberStructDefinition = lazyDefinition(() =>
    structDefinition<{a: number; b: number}>("NumberStruct", {
        returns: z.object({a: z.number(), b: z.number()}),
        parameters: z.object({
            struct: z.object({
                a: parameterValue(z.number()),
                b: parameterValue(z.number()),
            }),
        }),
    }),
)

@registerGraphNode
export class NumberStruct<Context = unknown> extends Struct<{a: number; b: number}, string, Context> {
    public override get definition() {
        return numberStructDefinition()
    }
}
